import './ErrorMessagePlayer.scss'

export default ({ }) => {
    return (
        <div className="error_in_player">
            <h1>No Stream</h1>
            <p>Stream is not available at this time. Please try again in a few minutes</p>
        </div>
    )
}
